import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import { Api } from "../app-controller.js";
import Swal from "sweetalert2";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import ModalPrecertificado from "../components/pre-certificado/ModalPrecertificado";
// import { TextareaAutosize } from "@material-ui/core";

class PreCertificate extends React.Component {
  initialState = {
    nivelUsuario: localStorage.nivel_actual,
    procesando: false,
    openModalPrecertificado: false,
    disableTipoProd: false,
    buscarProductos: {},
    solicitud_id: "",
    folio_solicitud: "",
    //establecimiento_id: "",
    pais_destino_id: "",
    pais_destino_name: "",
    num_factura: "",
    options_empaque: [],
    options_tipo_producto: [
      { id: "2", descripcion: "Veterinario" },
      { id: "4", descripcion: "Alimento" },
    ],
    //options_fin_exportacion : Api.loadCatalogue("cat_fin_exportacion"),
    options_countries: Api.loadCatalogue("countries"),
    options_unidad_medida: Api.loadCatalogue("cat_unidad_medida"),
    //Api.loadCatalogue("cat_estatus_tramite"),
    estatusTramiteCombo: [
      { id: "1", descripcion: "En espera" },
      { id: "5", descripcion: "Aceptada" },
      { id: "4", descripcion: "Rechazada" },
      { id: "0", descripcion: "Llenar precertificado" },
    ],
    options_tipo_precertificado: Api.loadCatalogue("cat_tipo_precertificado"),
    options_productos: [],
    tipo_precertificado_id: "",
    options_establecimientos: [],
    establecimiento: {
      //establecimiento del select
      id: "",
      razon_social: "",
      guid: "",
      actividades: [],
    },
    establecimiento_exportador: {
      id: "",
      razon_social: "",
      guid: "",
    },
    actividades: [],
    es_exportador: true,
    facturas: [],
    producto_registrado: {
      producto_id: "",
      no_registro: "",
      nombre_comercial: "",
      empaque_id: "", //falta
      empaque_name: "", //falta
      cantidad: "", // falta
      unidad_medida_id: "", //falta
      unidad_medida_name: "",
      fabricante: "", //falta
      pais_origen: "",
      presentacion_cantidad: "",
      tipo_precertificado_id: "",
      tipo_precertificado_name: "",
    },
    producto_no_registrado: {
      establecimiento_id: "", //fabricante
      establecimiento_razon_social: "",
      establecimiento_guid: "",
      pais_id: "",
      pais_name: "",
      nombre_comercial: "",
      cantidad_total: "",
      tipo_certificado_id: "",
      tipo_certificado_name: "",
      //EMPAQUE PRESENTACION
      empaque_id: "",
      empaque_name: "",
      //presentacion: "",
      presentacion_cantidad: "",
      presentacion_unidad_medida: "",
      presentacion_unidad_medida_name: "",
      tipo_precertificado_id: "",
      tipo_precertificado_name: "",
    },
    lista_productos_registrados: [],
    lista_productos_no_registrados: [],
    nombre_consignatario: "",
    lista_fabricantes: [],
    show_info_precertificado: false,
    show_seccion_exportador: false,
    tipo_documento_id: "",
    tipo_documentos: [],
    documentos: [],
    previa: false,
    previa_url: "",
    registros_docs: 0,
    cantidad_disponible: "",
    tipo_producto_id: "",
    disableEstablecimientoExportador: false,
    presentaciones: [],
    precertificado_solicitud_id: "",
    disableFabricante: false,
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;

    // this.handleCLV = this.handleCLV.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
    this.closeModalPrecertificado = this.closeModalPrecertificado.bind(this);
    this.limpiarCampos = this.limpiarCampos.bind(this);
    this.removeProductoRefrendado = this.removeProductoRefrendado.bind(this);
    this.mensajeError = this.mensajeError.bind(this);
    this.handleProductoRefrendado = this.handleProductoRefrendado.bind(this);
    this.handleNumFactura = this.handleNumFactura.bind(this);
    this.handlePaises = this.handlePaises.bind(this);
    this.AddCLV = this.AddCLV.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeCEE = this.handleChangeCEE.bind(this);
    this.handleFinExportacion = this.handleFinExportacion.bind(this);

    this.handleEstablecimiento = this.handleEstablecimiento.bind(this);
    this.handleGuidEstablecimiento = this.handleGuidEstablecimiento.bind(this);
    this.handleExisteEstablecimiento =
      this.handleExisteEstablecimiento.bind(this);

    this.handleChangeFabricante = this.handleChangeFabricante.bind(this);
    this.handleGuidFabricante = this.handleGuidFabricante.bind(this);
    this.handleExisteFabricante = this.handleExisteFabricante.bind(this);

    this.handleEmpaque = this.handleEmpaque.bind(this);
    this.addEmpaque = this.addEmpaque.bind(this);
    this.removeEmpaque = this.removeEmpaque.bind(this);

    this.handleOpenPrecertificado = this.handleOpenPrecertificado.bind(this);
    this.handleChangeEstablecimiento =
      this.handleChangeEstablecimiento.bind(this);
    this.handleChangeTipoProducto = this.handleChangeTipoProducto.bind(this);

    this.handleChangeProductoRegistrado =
      this.handleChangeProductoRegistrado.bind(this);
    this.addProductoRegistrado = this.addProductoRegistrado.bind(this);
    this.removeProductoRegistrado = this.removeProductoRegistrado.bind(this);

    this.handleChangeProductoNORegistrado =
      this.handleChangeProductoNORegistrado.bind(this);
    this.addProductoNORegistrado = this.addProductoNORegistrado.bind(this);
    this.removeProductoNORegistrado =
      this.removeProductoNORegistrado.bind(this);

    this.handleConsignatario = this.handleConsignatario.bind(this);
    this.handleChangePais = this.handleChangePais.bind(this);
    this.handleEstablecimientoNoExtranjero =
      this.handleEstablecimientoNoExtranjero.bind(this);

    this.handleFile = this.handleFile.bind(this);
    this.addDocument = this.addDocument.bind(this);
    this.removeDocument = this.removeDocument.bind(this);

    this.handleVistaPrevia = this.handleVistaPrevia.bind(this);
    this.handleCloseVistaPrevia = this.handleCloseVistaPrevia.bind(this);
    this.handleChangeTipoDocumento = this.handleChangeTipoDocumento.bind(this);
  }
  mi_grid = {};

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getSolicitudesPreCertificadoClient",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio_solicitud: {
          label: "Folio Solicitud",
        },
        num_factura: {
          label: "No. Factura",
        },
        razon_social: {
          /**este no se puede mostrar de donde lo pide */
          label: "Establecimiento",
          render: (me) => {
            if (me.data.razon_social !== null) {
              me.innerHTML = me.data.razon_social;
            } else {
              me.innerHTML = "";
            }
          },
        },
        tipo_precertificado: {
          label: "Tipo precertificado",
          render: (me) => {
            if (me.data.tipo_precertificado !== "Null") {
              me.innerHTML = me.data.tipo_precertificado;
            } else {
              me.innerHTML = "NA";
            }
          },
        },
        pais_destino: {
          label: "País destino",
          render: (me) => {
            if (me.data.pais_destino !== null) {
              me.innerHTML = me.data.pais_destino;
            } else {
              me.innerHTML = "";
            }
          },
        } /* 
        cantidad: {
          label: "Cantidad solicitada",
          render: (me) => {
            if (me.data.cantidad !== null || me.data.cantidad !== undefined) {
              me.innerHTML = me.data.cantidad;
            } else {
              me.innerHTML = "";
            }
          },
        },
        cantidad_disponible: {
          label: "Cantidad disponible",
          render: (me) => {
            if (
              me.data.cantidad_disponible !== null ||
              me.data.cantidad_disponible !== undefined
            ) {
              me.innerHTML = me.data.cantidad_disponible;
            } else {
              me.innerHTML = "";
            }
          },
        }, */,
        fecha_solicitud: {
          label: "Fecha Solicitud",
          render: (me) => {
            me.innerHTML = me.data.fecha_solicitud
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        descripcion: {
          label: "Estado",
          render: (me) => {
            if (me.data.estatus_precertificado === "5") {
              me.innerHTML = "Aceptada";
            } else if (me.data.estatus_precertificado === "4") {
              me.innerHTML = "Rechazada";
            } else if (me.data.estatus_precertificado === "1") {
              me.innerHTML = "En espera";
            } else if (me.data.estatus_precertificado === "0" && me.data.estatus_tramite_id === "3") {
              me.innerHTML = "Llenar precertificado";
            }
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-list",
          btnClass: "btn bg-gradient-green",
          btnClick: (data) => {
            this.handleOpenPrecertificado(data);
          },
          render: (me, data) => {
            if (data.cantidad_disponible === "0" && data.estatus_precertificado !== "0" ) {
              me.remove();
            } //modificar el condicional para cuando este en espera de pago
          },
        },
      ],
    };

    this.mi_grid = Api.grid(grid);

    let busqueda = Api.form({
      target: "#busqueda",
      /*onchange: (me, data, serial) => {
                mi_grid.go(1, serial);
            },*/
      render: (form) => {
        /** Cargamos el combo de pais */
        let paises = Api.loadCatalogue("countries");
        let option_p = "<option value=0>Seleccione país</option>";
        for (let p in paises) {
          option_p += `<option value="${paises[p].id}">
                        ${paises[p].descripcion}
                    </option>`;
        }
        form.querySelector("#pais").innerHTML = option_p;
        /* Fin de la carga país */

        /** Cargamos el combo de estatus */
        let estatus = Api.loadCatalogue("cat_tipo_precertificado");
        let option_e = `<option value="0">Seleccione</option>`;
        for (let e in estatus) {
          option_e += `<option value="${estatus[e].id}">${estatus[e].descripcion}</option>`;
        }
        form.querySelector("#tipo_precertificado").innerHTML = option_e;

        /* Fin de la carga estatus */
      },

      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio_solicitud",
            label: "Folio solicitud",
            placeHolder: "Folio solicitud",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "fabricante",
            label: "Establecimiento",
            placeHolder: "Establecimiento",
            cols: 5,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "pais",
            label: "País destino",
            placeHolder: "País destino",
            cols: 4,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "tipo_precertificado",
            label: "Tipo de precertificado",
            placeHolder: "Tipo de precertificado",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 2,
            value: "",
          },
        },
        {
          select: {
            cols: 2,
            name: "estado",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                /*  if (
                  //s.id === "1" ||
                  s.id === "3" ||
                  s.id === "4" ||
                  s.id === "5" ||
                  s.id === "8" ||
                  s.id === "9" 
                ) {
                  if (s.id === "3") {
                    me.innerHTML += `<option value=${s.id}>Llenar precertificado</option>`;
                  } else {
                    me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
                  } */
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 3,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarProductos: busqueda.data() });
              let search = this.state.buscarProductos;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              this.mi_grid.go(1, src);
            },
          },
        },
      ],
    });
  }

  handleOpenPrecertificado(inf) {
    let data = inf;

    this.setState({
      solicitud_id: data.solicitud_id,
      folio_solicitud: data.folio_solicitud,
      establecimiento_id: data.establecimiento_id,
      num_factura: data.num_factura,
      tipo_precertificado_id: data.tipo_precertificado_id,
      cantidad_disponible: data.cantidad_disponible,
      precertificado_solicitud_id: data.id,
    });

    //cosas precargadas
    //NOS TRAEMOS LOS ESTABLECIMIENTOS donde yo sea regente o representante
    Api.fetch("app/getEstablecimientosRegRep").then((data) => {
      if (data) {
        const array = [];
        Object.keys(data).map((index) => {
          array.push(data[index]);
        });

        this.setState({
          options_establecimientos: array,
          show_seccion_exportador: false,
          openModalPrecertificado: true,
          disableTipoProd: false,
        });

        Api.fetch("app/getInformacionPrecertificadoFormulario").then((docs) => {
          if (docs) {
            this.setState({
              tipo_documentos: docs.documentos,
              registros_docs: docs.documentos.length,
              facturas: docs.facturas,
            });
          }
        });
      }
    });
  }

  /**
   * limpiar 1, no limpiar 0
   */
  closeModalPrecertificado(limpiar) {
    Swal.fire({
      title: "¿Seguro que quiere cerrar el formulario de precertificado?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ openModalPrecertificado: false });
        if (limpiar === 1) {
          this.limpiarCampos(1);
        }
      }
    });
  }

  limpiarCampos(e) {
    let establecimiento = { ...this.state.establecimiento };

    if (e === 1) {
      establecimiento["razon_social"] = "";
      establecimiento["guid"] = "";
      establecimiento["id"] = "";

      this.setState({
        solicitud_id: this.initialState.solicitud_id,
        folio_solicitud: this.initialState.folio_solicitud,
        establecimiento: establecimiento,
        establecimiento_exportador:
          this.initialState.establecimiento_exportador,
        options_establecimientos: this.initialState.options_establecimientos,
        tipo_precertificado_id: this.initialState.tipo_precertificado_id,
        options_productos: this.initialState.options_productos,
        options_empaque: this.initialState.options_empaque,
        pais_destino_id: this.initialState.pais_destino_id,
        pais_destino_name: this.initialState.pais_destino_name,
        producto_exportacion: this.initialState.producto_exportacion,
        producto_registrado: this.initialState.producto_registrado,
        producto_no_registrado: this.initialState.producto_no_registrado,
        lista_productos_registrados:
          this.initialState.lista_productos_registrados,
        lista_productos_no_registrados:
          this.initialState.lista_productos_no_registrados,
        nombre_consignatario: this.initialState.nombre_consignatario,
        show_info_precertificado: this.initialState.show_info_precertificado,
        show_seccion_exportador: this.initialState.show_seccion_exportador,
        tipo_documento_id: this.initialState.tipo_documento_id,
        tipo_documentos: this.initialState.tipo_documentos,
        documentos: this.initialState.documentos,
      });
    } else {
      establecimiento["razon_social"] = "";
      establecimiento["guid"] = "";

      this.setState({
        solicitud_id: this.initialState.solicitud_id,
        folio_solicitud: this.initialState.folio_solicitud,
        establecimiento: establecimiento,
        establecimiento_exportador:
          this.initialState.establecimiento_exportador,
        //options_establecimientos: this.initialState.options_establecimientos,
        options_productos: this.initialState.options_productos,
        options_empaque: this.initialState.options_empaque,
        pais_destino_id: this.initialState.pais_destino_id,
        pais_destino_name: this.initialState.pais_destino_name,
        producto_exportacion: this.initialState.producto_exportacion,
        producto_registrado: this.initialState.producto_registrado,
        producto_no_registrado: this.initialState.producto_no_registrado,
        lista_productos_registrados:
          this.initialState.lista_productos_registrados,
        lista_productos_no_registrados:
          this.initialState.lista_productos_no_registrados,
        nombre_consignatario: this.initialState.nombre_consignatario,
        show_info_precertificado: this.initialState.show_info_precertificado,
        disableTipoProd: this.initialState.disableTipoProd,
        tipo_producto_id: this.initialState.tipo_producto_id,
        options_tipo_producto: this.initialState.options_tipo_producto,
        disableEstablecimientoExportador:
          this.initialState.disableEstablecimientoExportador,
      });

      let adr = document.querySelector("#addEst");
      adr.classList = "btn btn-light";
      document.querySelector("#addEst i").classList = "fa fa-th";
    }
  }

  handleProductoRefrendado = (e) => {
    let name = this.state.options_productos_refrendados.find(
      (d) => d.id.toString() === e.target.value
    );

    if (e.target.value !== "" && name !== undefined) {
      this.setState({
        producto_r: e.target.value,
        producto_name: name.nombre_comercial,
      });
    } else {
      this.setState({
        producto_r: e.target.value,
      });
    }
  };

  handleNumFactura = (e) => {
    this.setState({
      num_factura: e.target.value,
    });
  };

  handlePaises = (e) => {
    this.setState({
      paises: e,
    });
  };

  handleFinExportacion = (e) => {
    let name = this.state.options_fin_exportacion.find(
      (d) => d.id === e.target.value
    );
    this.setState({
      fin_exportacion: e.target.value,
      fin_exportacion_name: name.descripcion,
    });
  };

  removeProductoRefrendado(e) {
    let lista_productos = [...this.state.productos_refrendados];
    lista_productos.splice(e.target.id, 1);
    this.setState({ productos_refrendados: lista_productos });
  }

  AddCLV(e) {
    let obj_s = e;

    let esta_bien = 1;

    if (obj_s.producto_r === "") {
      this.mensajeError("Atención", "Favor de seleccionar un producto.");
      esta_bien = 0;
    }

    if (obj_s.paises.length === 0) {
      this.mensajeError("Atención", "Favor de seleccionar al menos un país.");
      esta_bien = 0;
    }

    if (obj_s.fin_exportacion === "") {
      this.mensajeError("Atención", "Favor de ingresar fin de exportación.");
      esta_bien = 0;
    }

    //if (obj_s.causas_sancion.length === 0 || obj_s.causas_sancion === null) {
    if (obj_s.num_factura === "") {
      this.mensajeError("Atención", "Favor de ingresar número de factura.");
      esta_bien = 0;
    }

    if (esta_bien) {
      let productos_r = [...this.state.productos_refrendados];

      let lista = [];
      for (let e in obj_s.paises) {
        let objeto = {
          num_factura: obj_s.num_factura,
          pais_id: obj_s.paises[e].id,
          pais_name: obj_s.paises[e].descripcion,
          producto_name: obj_s.producto_name,
          producto_r: obj_s.producto_r,
          fin_exportacion: obj_s.fin_exportacion,
          fin_exportacion_name: this.state.fin_exportacion_name,
        };
        lista.push(objeto);
      }
      for (let e in lista) {
        //checamos si el producto con su pais ya ha sido insertado
        let existe_prod = productos_r.find(
          (d) =>
            d.producto_r === lista[e].producto_r &&
            d.pais_id === lista[e].pais_id
        );
        if (existe_prod === undefined) {
          productos_r.push(lista[e]);
        }
      }

      this.setState({
        productos_refrendados: productos_r,
        //obj_s: this.state.sancion,
      });
      //this.limpiarCampos(1);
    }
  }

  mensajeError(titulo, msg) {
    Swal.fire({
      title: titulo,
      icon: "warning",
      text: msg,
    });
  }

  handleConsignatario(e) {
    this.setState({ nombre_consignatario: e.target.value.toUpperCase() });
  }

  handleChangePais(e) {
    this.setState({ pais_destino_id: e.target.value });
  }

  handleChangeProductoRegistrado(e) {
    let prod = { ...this.state.producto_registrado };

    if (e.target.name === "producto_id") {
      //buscar precentaciones
      Api.fetch(
        "app/getProductPresentation?producto_id=" + e.target.value
      ).then((response) => {
        if (response) {
          this.setState({ presentaciones: response });
        }
      });
    }

    if (e.target.name === "empaque_id") {
      let empaque_name = this.state.presentaciones.find(
        (d) => d.id === e.target.value //trae el id del producto
      );

      prod["empaque_name"] = empaque_name.empaque;
      prod["unidad_medida_id"] = empaque_name.unidad_medida_id;
      prod["unidad_medida_name"] = empaque_name.unidad_medida;
      prod["presentacion_cantidad"] = empaque_name.cantidad;
    }

    if (e.target.name === "tipo_precertificado_id") {
      let tipo_certificado = this.state.options_tipo_precertificado.find(
        (d) => d.id.toString() === e.target.value
      );
      prod["tipo_precertificado_name"] = tipo_certificado.descripcion;
    }

    if (e.target.name === "cantidad") {
      let entero = /^[1-9]\d*$/;
      if (e.target.value === "" || entero.test(e.target.value)) {
        prod["cantidad"] = e.target.value;
        this.setState({ producto_registrado: prod });
      } else {
        return;
      }
    }

    prod[e.target.name] = e.target.value;
    this.setState({ producto_registrado: prod });
  }

  addProductoRegistrado(e) {
    let producto_registrado = { ...this.state.producto_registrado };
    let lista_productos_registrados = [
      ...this.state.lista_productos_registrados,
    ];

    if (producto_registrado["producto_id"] !== "") {
      //checamos que no este en la lista de productos registrados
      let existe = lista_productos_registrados.find(
        //(l) => l.producto_id === producto_registrado["producto_id"]
        (l) => l.empaque_id === producto_registrado["empaque_id"]
      );
      if (!existe) {
        if (producto_registrado["cantidad"] !== "") {
          //buscamos la info del producto
          Api.fetch(
            "app/getProductoInfo?id=" + producto_registrado["producto_id"]
          ).then((data) => {
            if (data) {
              producto_registrado["no_registro"] =
                data[0].no_registro;
              producto_registrado["nombre_comercial"] =
                data[0].nombre_comercial;
              producto_registrado["pais_origen"] = data[0].pais_name;

              lista_productos_registrados.push(producto_registrado);
              producto_registrado = this.initialState.producto_registrado;
              this.setState({
                lista_productos_registrados: lista_productos_registrados,
                producto_registrado: producto_registrado,
                presentaciones: [],
              });
            }
          });
        }
      }
    }
  }

  removeProductoRegistrado(e) {
    let lista_productos_registrados = [
      ...this.state.lista_productos_registrados,
    ];
    lista_productos_registrados.splice(e.target.id, 1);
    this.setState({
      lista_productos_registrados: lista_productos_registrados,
    });
  }

  handleChangeProductoNORegistrado(e) {
    let prod = { ...this.state.producto_no_registrado };

    switch (e.target.name) {
      case "pais_id":
        //buscamos el nombre del pais
        let pais_name = this.state.options_countries.find(
          (d) => d.id.toString() === e.target.value
        );
        //seteamos el nombre
        prod["pais_name"] = pais_name.descripcion;
        break;
      case "tipo_precertificado_id":
        let tipo_certificado = this.state.options_tipo_precertificado.find(
          (d) => d.id.toString() === e.target.value
        );
        prod["tipo_precertificado_name"] = tipo_certificado.descripcion;
        break;
      case "cantidad_total":
        let entero = /^[1-9]\d*$/;
        if (e.target.value === "" || entero.test(e.target.value)) {
          prod["cantidad"] = e.target.value;
          this.setState({ producto_no_registrado: prod });
        } else {
          return;
        }
        break;
      default:
        break;
    }

    prod[e.target.name] = e.target.value.toUpperCase();
    this.setState({ producto_no_registrado: prod });
  }

  addProductoNORegistrado(e) {
    let producto_no_registrado = { ...this.state.producto_no_registrado };

    let lista_productos_no_registrados = [
      ...this.state.lista_productos_no_registrados,
    ];

    if (
      producto_no_registrado["nombre_comercial"] !== "" &&
      producto_no_registrado["pais_id"] !== "" &&
      producto_no_registrado["cantidad_total"] !== "" &&
      producto_no_registrado["empaque_id"] !== "" &&
      producto_no_registrado["presentacion_cantidad"] !== "" &&
      producto_no_registrado["presentacion_unidad_medida"] !== ""
    ) {
      //  tipo_certificado_id: "",
      //  tipo_certificado_name: "",
      //checamos que no este en la lista de productos NO registrados
      //let existe = (lista_productos_no_registrados.find((l)=> l.producto_id === producto_registrado['producto_id']));
      //if(!existe){

      let adrFab = document.querySelector("#addEstFab");
      adrFab.classList = "btn btn-light";
      document.querySelector("#addEstFab i").classList = "fa fa-th";

      lista_productos_no_registrados.push(producto_no_registrado);
      producto_no_registrado = this.initialState.producto_no_registrado;
      this.setState({
        lista_productos_no_registrados: lista_productos_no_registrados,
        producto_no_registrado: producto_no_registrado,
        disableFabricante: false,
      });
      //}
    }
  }

  removeProductoNORegistrado(e) {
    let lista_productos_no_registrados = [
      ...this.state.lista_productos_no_registrados,
    ];
    lista_productos_no_registrados.splice(e.target.id, 1);
    this.setState({
      lista_productos_no_registrados: lista_productos_no_registrados,
    });
  }

  handleEstablecimiento(e) {
    let est = { ...this.state.establecimiento };
    est[e.target.name] = e.target.value.toUpperCase();
    this.setState({ establecimiento: est });
    //LIMPIAR CAMPOS
  }

  handleGuidEstablecimiento(e) {
    let est = {
      razon_social: this.state.establecimiento.razon_social, //this.getid("razon_social_e").value,
      guid: this.state.establecimiento.guid, //this.state.establecimiento.guid//this.getid("guid_e").value,
      est_solicita_id: this.state.establecimiento.id,
    };

    if (est.razon_social === "" || est.guid === "") {
      return;
    }
    //Api.loading(true);
    Api.fetch("app/getValidEstablishment", est, "POST").then((data) =>
      this.handleExisteEstablecimiento(est, data)
    );
  }

  handleExisteEstablecimiento(est, data) {
    //si existe checamos si tiene actividad de exportador
    if (data.id) {
      let est_id = data.id; //id del exportador
      //checar que onda cuando son los dos tipos de establecimiento
      Api.fetch(
        "app/getActividadesEstablecimiento?establecimiento_id=" + data.id
      ).then((data) => {
        if (data) {
          data.forEach((act) => {
            if (this.state.actividades.includes(act.id)) {
              this.setState({ disableEstablecimientoExportador: true });

              let adr = document.querySelector("#addEst");
              adr.classList = "btn btn-success";
              document.querySelector("#addEst i").classList = "fas fa-check";

              /* adr.addEventListener(
                "click",
                (e) => {
                  let establecimiento = { ...this.state.establecimiento };
                  let establecimiento_exportador = {
                    ...this.state.establecimiento_exportador,
                  };
                  if (adr.classList === "btn btn-light") {
                    return;
                  }
                  let est = {//este seria el establecimiento exportador
                    razon_social: establecimiento["razon_social"],
                    guid: establecimiento["guid"],
                    id: est_id,//establecimiento["id"], //est.id,
                  };

                  //campos estan vacios entonces no agregamos
                  if (est.razon_social !== "" && est.guid !== "") {
                    //let establecimiento_exportador = {...this.state.establecimiento_exportador};
                    /* establecimiento_exportador["id"] = est_id;
                    establecimiento_exportador["razon_social"] =
                      est.razon_social; 

                    adr.classList = "btn btn-light";
                    document.querySelector("#addEst i").classList = "fa fa-th";

                    let establecimiento = { ...this.state.establecimiento };

                    establecimiento["razon_social"] = "";
                    establecimiento["guid"] = "";

                    this.setState({
                      establecimiento_exportador: est,
                      establecimiento: establecimiento,
                    });
                  }
                },
                { once: true }
              ); */

              let establecimiento = { ...this.state.establecimiento };
              let est = {
                //este seria el establecimiento exportador
                razon_social: establecimiento["razon_social"],
                guid: establecimiento["guid"],
                id: est_id,
              };

              /*  establecimiento["razon_social"] = "";
              establecimiento["guid"] = "";
 */
              this.setState({
                establecimiento_exportador: est,
                establecimiento: establecimiento,
              });
            }
          });
        }
      });
    } else {
      Swal.fire({
        title: "Error al ingresar el establecimiento",
        icon: "warning",
        text: "Favor de ingresar un establecimiento con licencia vigente.",
      });
    }
  }

  handleChangeFabricante(e) {
    let producto_no_registrado = { ...this.state.producto_no_registrado };
    producto_no_registrado["establecimiento_" + e.target.name] =
      e.target.value.toUpperCase();
    this.setState({ producto_no_registrado: producto_no_registrado });
  }

  handleGuidFabricante(e) {
    let est = {
      razon_social:
        this.state.producto_no_registrado.establecimiento_razon_social, //this.getid("razon_social_e").value,
      guid: this.state.producto_no_registrado.establecimiento_guid, //this.state.establecimiento.guid//this.getid("guid_e").value,
      est_solicita_id: this.state.establecimiento.id,
    };

    let producto_no_registrado = { ...this.state.producto_no_registrado };

    let adrFab = document.querySelector("#addEstFab");

    if (adrFab.classList === "btn btn-red") {
      adrFab.classList = "btn btn-light";
      document.querySelector("#addEstFab i").classList = "fa fa-th";

      //let producto = {...this.state.producto_no_registrado};
      producto_no_registrado["establecimiento_id"] = "";
      producto_no_registrado["establecimiento_razon_social"] = "";
      producto_no_registrado["establecimiento_guid"] = "";

      this.setState({
        producto_no_registrado: producto_no_registrado,
        disableFabricante: false,
      });
      return;
    }

    if (est.razon_social === "" || est.guid === "") {
      return;
    }
    //Api.loading(true);
    Api.fetch("app/getValidEstablishment", est, "POST").then((data) =>
      this.handleExisteFabricante(est, data)
    );
  }

  handleExisteFabricante(est, data) {
    //si existe checamos si tiene actividad de FABRICANTE
    let establecimiento_id = data.id;
    let act_fabricante = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    let producto_no_registrado = { ...this.state.producto_no_registrado };
    let es_fabricante = false;
    if (data.id) {
      //checar cuando son los dos tipos de establecimiento
      Api.fetch(
        "app/getActividadesEstablecimiento?establecimiento_id=" + data.id
      ).then((data_f) => {
        if (data_f) {
          data_f.forEach((act) => {
            if (act_fabricante.includes(act.id)) {
              es_fabricante = true;
              producto_no_registrado["establecimiento_id"] = establecimiento_id;
            }
          });
          //como es fabricante, cambiamos el boton a success

          let adrFab = document.querySelector("#addEstFab"); //toma referencia de boton
          if (this.state.disableFabricante) {
            adrFab.classList = "btn btn-red";
            document.querySelector("#addEstFab i").classList = "fa fa-times";
          } else {
            adrFab.classList = "btn btn-success";
            document.querySelector("#addEstFab i").classList = "fas fa-check";
            this.setState({ disableFabricante: true });
          }
          //se agrega event listener una vez que se sabe que el establecimiento es valido. Usuario decide o no agregarlo
          //Puro fin estetico, debido a que lo unico que hace es cambiar boton a check verde
          //Proceso puede seguir sin este evento
          adrFab.addEventListener(
            "click",
            (e) => {
              if (adrFab.classList === "btn btn-light") {
                return;
              }

              if (adrFab.classList.value === "btn btn-red") {
                //caso en que el boton es x roja
                //cambiamos boton a original
                adrFab.classList = "btn btn-light";
                document.querySelector("#addEstFab i").classList = "fa fa-th";
                //limpiamos los campos
                producto_no_registrado["establecimiento_id"] = "";
                producto_no_registrado["establecimiento_razon_social"] = "";
                producto_no_registrado["establecimiento_guid"] = "";
                //desbloqueamos inputs
                this.setState({
                  producto_no_registrado: producto_no_registrado,
                  disableFabricante: false,
                });
                return;
              }

              let est = {
                razon_social:
                  producto_no_registrado["establecimiento_razon_social"],
                guid: producto_no_registrado["establecimiento_guid"],
              };

              //si campos estan vacios entonces no agregamos
              if (est.razon_social !== "" && est.guid !== "") {
                //si es correcto y tiene información cambiamos el boton a x roja
                adrFab.classList = "btn btn-red";
                document.querySelector("#addEstFab i").classList =
                  "fa fa-times";

                this.setState({ disableFabricante: true });
              }
              this.setState({ producto_no_registrado: producto_no_registrado });
            },
            { once: true }
          );

          if (!es_fabricante) {
            Swal.fire({
              title: "Error al ingresar el establecimiento",
              icon: "warning",
              text: "Favor de ingresar un establecimiento con licencia vigente y actividad de fabricante.",
            }).then((result) => {
              this.setState({ disableFabricante: false });
            });
          }
          //this.setState({ options_activities: data.actividades });
        }
      });
    } else {
      Swal.fire({
        title: "Error al ingresar el establecimiento",
        icon: "warning",
        text: "Favor de ingresar un establecimiento con licencia vigente.",
      });
    }
  }

  handleChangeCEE(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };

    producto_exportacion[e.target.name] = e.target.value.toUpperCase();

    this.setState({ producto_exportacion: producto_exportacion });
  }

  /* Funcion que trae la lista de actividades del establecimiento seleccionado y nos dice si tiene actividad de exportador o no */
  handleChangeEstablecimiento(e) {
    //si se cambia el establecimiento reiniciamos el modal
    this.limpiarCampos(2);
    //checamos el tipo de precertificado que se selecciono en la solicitud
    let act = [];
    //dependiendo el tipo de certificado son las actividades que vamos a considerar
    switch (this.state.tipo_precertificado_id) {
      case "1": //-exportador
        act.push(5);
        break;
      case "2": //-reexportador
        act.push(23);
        break;
      case "3": //-exportador y reexportador
        act = [5, 23];
        break;
      default:
        break;
    }

    let establecimiento = { ...this.state.establecimiento };

    establecimiento["id"] = e.target.value;
    establecimiento["razon_social"] = "";
    establecimiento["guid"] = "";
    this.setState({ establecimiento: establecimiento, actividades: act });
    let establecimiento_id = e.target.value;

    //a partir de esto buscamos si contienen dichas actividades
    Api.fetch(
      "app/getActividadesEstablecimiento?establecimiento_id=" +
        establecimiento_id
    ).then((data) => {
      if (data) {
        //let ee = false;//this.state.es_exportador;
        let actividades = [];

        data.map(function (e) {
          actividades.push(e.id);
        });

        var result = actividades.filter(function (item) {
          return act.indexOf(item) > -1;
        });

        var ee = result.length > 0 ? false : true;
        var es_exportador = result.length > 0 ? true : false;

        this.setState({
          show_seccion_exportador: ee /* ,show_info_precertificado:ee */,
          es_exportador: es_exportador,
        });
      }
    });
  }

  handleChangeTipoProducto(e) {
    let tipo_producto_id = e.target.value;
    let tipo_producto_name = this.state.options_tipo_producto.find(
      (d) => d.id === e.target.value
    );
    let options_empaque = [];
    //let tipo_producto = tipo_producto_id === "2" ? [1, 2] : [3, 4];
    let tipo_producto = tipo_producto_id === "2" ? [1, 2, 3, 4] : [5];//Si es veterinario

    //CHECAMOS EL TIPO DEL ESTABLECIMIENTO PARA LLENAR LOS SELECTS DE INGREDIENTES
    //VETERINARIO
    if (tipo_producto_id === "2") {
      Api.fetch("cat/getEmpaqueTipoProducto").then((data) => {
        if (data) {
          options_empaque = data.tipo_1;
          this.setState({
            options_empaque: options_empaque,
          });
        }
      });
    }
    //ALIMENTO
    if (tipo_producto_id === "4") {
      Api.fetch("cat/getEmpaqueTipoProductoAlimento").then((data) => {
        if (data) {
          options_empaque = data.empaque_tipo_alimento;
          this.setState({
            options_empaque: options_empaque,
          });
        }
      });
    }

    //checamos si establecimiento_exportador.id esta vacio (significa que no agregaron otro establecimiento);
    let establecimiento = { ...this.state.establecimiento };
    let establecimiento_exportador = {
      ...this.state.establecimiento_exportador,
    };
    let est = "";
    if (establecimiento_exportador["id"] !== "") {
      est = establecimiento_exportador["id"];
    } else {
      est = establecimiento["id"];
    }

    //obtenemos los productos del establecimiento seleccionado a partir del tipo de producto
    Api.fetch(
      "app/getProductosEstablecimientoTipo",
      { establecimiento_id: est, tipo_producto: tipo_producto },
      "post"
    ).then((data) => {
      if (data) {
        if (data.length === 0 && tipo_producto_id !== "") {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text:
              "El establecimiento seleccionado no cuenta con productos de tipo " +
              tipo_producto_name.descripcion +
              ".",
          });
          return;
        } else if (tipo_producto_id !== "") {
          this.setState({
            options_productos: data,
            tipo_producto_id: tipo_producto_id,
            disableTipoProd: true,
            show_info_precertificado: true,
          });
        }
      }
    });
  }

  handleFile(e) {
    let file = e.files[0];
    /**
     * file
     * name: "REF-004-21.pdf"
     * size: 2356
     * type: "application/pdf"
     * webkitRelativePath: ""
     */
    let ext = file.type.split("/")[1];
    let carga = [];
    var reader = new FileReader();

    let nom_tdocumento = "";
    for (let i in this.state.tipo_documentos) {
      if (this.state.tipo_documentos[i].id === this.state.tipo_documento_id) {
        nom_tdocumento = this.state.tipo_documentos[i].descripcion;
        break;
      }
    }

    let data = {
      nombre: file.name,
      type: ext,
      archivo: e.name,
      tipo_documento_id: this.state.tipo_documento_id,
      tipo_documento: nom_tdocumento,
    };

    if (file) {
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        data.data = reader.result;
      };
      carga.push(data);
    }

    this.addDocument(carga);
  }

  addDocument(documento) {
    let doc = documento[0];
    let pa = [...this.state.documentos];

    for (let i in this.state.documentos) {
      if (pa[i].nombre === doc.nombre) {
        Swal.fire({
          title: "Atención",
          text: "Ya cuenta con este documento en su lista.",
        });
        return;
      }
    }

    pa.push(doc);
    this.setState({
      documentos: pa,
    });

    //tengo que quitar el documento del select
    let lista = [...this.state.tipo_documentos];
    for (let i in this.state.tipo_documentos) {
      if (lista[i].id === doc.tipo_documento_id) {
        lista.splice(parseInt(i), 1);
        break;
      }
    }
    this.setState({ tipo_documentos: lista });
  }

  removeDocument(e) {
    let id = e.target.getAttribute("data-tipo_documento_id");
    let descripcion = e.target.getAttribute("data-descripcion");

    let lista = [...this.state.documentos];
    lista.splice(e.target.id, 1);
    this.setState({ documentos: lista });

    //agregamos de nuevo en el select
    let array = [];
    let obj_tipo_documento = {
      id: id,
      descripcion: descripcion,
    };

    array.push(obj_tipo_documento);
    this.setState({ tipo_documentos: array });
  }

  handleVistaPrevia(e) {
    let file = this.state.documentos[e.target.id].data;
    file = file.substr("data:application/pdf;base64,".length);
    this.setState({ previa: true, previa_url: file });
  }

  handleCloseVistaPrevia(e) {
    this.setState({ previa: false });
  }

  handleChangeTipoDocumento(e) {
    this.setState({ tipo_documento_id: e.target.value });
  }

  /* EMPAQUE */

  handleEmpaque(e) {
    let producto_no_registrado = { ...this.state.producto_no_registrado };

    if (e.target.name === "empaque_id" && e.target.value !== "") {
      let empaque_name = this.state.options_empaque.find(
        (d) => d.id === e.target.value
      );
      producto_no_registrado["empaque_name"] = empaque_name.descripcion;
    } else if (
      e.target.name === "presentacion_unidad_medida" &&
      e.target.value !== ""
    ) {
      let presentacion_unidad_medida = this.state.options_unidad_medida.find(
        (d) => d.id === e.target.value
      );
      producto_no_registrado["presentacion_unidad_medida_name"] =
        presentacion_unidad_medida.descripcion;
    } else if (e.target.name === "presentacion_cantidad") {
      let entero = /^[1-9]\d*$/;
      if (e.target.value === "" || entero.test(e.target.value)) {
        producto_no_registrado["presentacion_cantidad"] = e.target.value;
        this.setState({ producto_no_registrado: producto_no_registrado });
      } else {
        return;
      }
    }

    producto_no_registrado[e.target.name] = e.target.value.toUpperCase();

    this.setState({ producto_no_registrado: producto_no_registrado });
  }

  addEmpaque(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };
    let rep = { ...this.state.producto_exportacion["empaque"] };
    let pa = [...this.state.producto_exportacion["empaques"]];

    pa.push(rep);
    producto_exportacion["empaques"] = pa;
    this.setState({
      producto_exportacion: producto_exportacion,
    });
  }

  removeEmpaque(e) {
    let producto_exportacion = { ...this.state.producto_exportacion };
    let pa = [...this.state.producto_exportacion["empaques"]];
    pa.splice(e.target.id, 1);
    producto_exportacion["empaques"] = pa;
    this.setState({
      producto_exportacion: producto_exportacion,
    });
  }

  handleEstablecimientoNoExtranjero() {
    this.setState({
      /* show_info_precertificado:true, */ show_seccion_exportador: false,
    });
  }

  handleSubmit() {
    let valido = 1;

    if (this.state.registros_docs > 0 && this.state.documentos.length === 0) {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de ingresar los documentos correspondientes.",
      });
      valido = 0;
    }

    if (this.state.pais_destino_id === "") {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de seleccionar el pais destino.",
      });
      valido = 0;
    }

    if (this.state.nombre_consignatario === "") {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de ingresar el nombre del consignatario.",
      });
      valido = 0;
    }

    if (this.state.lista_productos_registrados.length === 0) {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de ingresar mínimo un producto registrado.",
      });
      valido = 0;
    }

    if (this.state.tipo_producto_id === "") {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de seleccionar el tipo de producto.",
      });
      valido = 0;
    }

    if (this.state.establecimiento.id === "") {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de seleccionar el establecimiento.",
      });
      valido = 0;
    }

    if (valido) {
      Swal.fire({
        title: "¿Seguro que desea realizar la solicitud? ",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/generarPrecertificado",
            {
              documentos: this.state.documentos,
              lista_productos_registrados:
                this.state.lista_productos_registrados,
              lista_productos_no_registrados:
                this.state.lista_productos_no_registrados,
              nombre_consignatario: this.state.nombre_consignatario,
              num_factura: this.state.num_factura,
              solicitud_id: this.state.solicitud_id,
              pais_destino_id: this.state.pais_destino_id,
              establecimiento: this.state.establecimiento,
              establecimiento_exportador: this.state.establecimiento_exportador,
              cantidad_disponible: this.state.cantidad_disponible,
              tipo_producto_id: this.state.tipo_producto_id,
              es_exportador: this.state.es_exportador,
              precertificado_solicitud_id:
                this.state.precertificado_solicitud_id,
              tipo_precertificado_id: this.state.tipo_precertificado_id,
            },
            "POST"
          ).then((data) => {
            Swal.fire({
              title: "Se realizó con éxito la solicitud de precertificado",
              icon: "success",
              //text: data.message,
            }).then(() => {
              this.setState({ openModalPrecertificado: false });
              this.limpiarCampos(1);
              //this.grid.go(1);
              this.mi_grid.go(0);
              //window.location.reload();
            });
          });
        }
      });
    }
  }

  handleRegister(e) {
    if (e.message !== "Su información ha sido recibida exitosamente.") {
      /*    Swal.fire({
            title: "Atención, verifique el formulario.",
            icon: "error",
            //html: tplErrors,
          }); */
    } else {
      Swal.fire({
        title: "Información recibida",
        icon: "success",
        text: e.message,
      }).then(() => {
        this.setState({ openModalCEE: false });
        this.limpiarCampos(1);
        this.mi_grid.go(0);
        //window.location.reload();
      });
    }
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/productos/precertificados">Productos</Link>
          </li>
          <li className="breadcrumb-item active">Precertificados</li>
        </ol>
        <h1 className="page-header">Precertificados</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>
        <div className="hide">
          <fieldset id="cargaDocs"></fieldset>
        </div>

        {/**CEE */}
        <Modal
          isOpen={this.state.openModalPrecertificado}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModalPrecertificado(1);
              //this.limpiarCampos(1);
            }}
            className="text-center"
          >
            No. de factura: {this.state.num_factura}
          </ModalHeader>
          <ModalBody>
            <ModalPrecertificado
              key={this.state.num_factura}
              component={this}
              state={this.state}
            />
          </ModalBody>
        </Modal>
        <div
          className={
            this.state.procesando ? "progress rounded-corner m-b-15" : "hide"
          }
        >
          <div
            className="progress-bar bg-purple progress-bar-striped progress-bar-animated"
            style={{ width: "100%", height: "20px" }}
          >
            <h4>Cargando, espere...</h4>
          </div>
        </div>
      </div>
    );
  }
}

export default PreCertificate;